import { Link } from '@liveauctioneers/hammer-ui-core/link';
import React from 'react';

import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';
import { getCheckoutUrl, getCheckoutUrlATG, getReviewUrl } from '@/utils/urls';

type Props = {
    atgPayActive: boolean;
    bidderIsSuspended: boolean;
    catalogId: number;
    invoiceId: number;
    isLivePayments: boolean;
    paidStatus: string;
    reviewLink: React.ReactNode;
    reviewed: boolean;
    sent: boolean;
    showGetHelpModal?: () => void;
};

export const WonItemsLinks = ({
    atgPayActive,
    bidderIsSuspended,
    catalogId,
    isLivePayments,
    paidStatus,
    reviewed,
    reviewLink,
    sent,
    showGetHelpModal,
}: Props) => {
    const formatMessage = useAppFormatMessage();

    return (
        <>
            {paidStatus === 'paid' && sent && isLivePayments && (
                <div className="mb-sm">
                    <Link
                        size="sm"
                        href={atgPayActive ? getCheckoutUrlATG(catalogId) : getCheckoutUrl(catalogId)}
                    >
                        {formatMessage(['view_order_details'])}
                    </Link>
                </div>
            )}
            <div className="mb-sm">
                <Link
                    size="sm"
                    onClick={showGetHelpModal}
                >
                    {formatMessage(['support_center'])}
                </Link>
            </div>
            {!bidderIsSuspended && React.isValidElement(reviewLink) && <div>{reviewLink}</div>}
            {reviewed && (
                <div className="mb-sm">
                    <Link
                        size="sm"
                        href={getReviewUrl(catalogId)}
                    >
                        {formatMessage(['read_review'])}
                    </Link>
                </div>
            )}
        </>
    );
};
